import React, {Dispatch, FC, SetStateAction, useCallback} from 'react'

import cn from 'classnames/bind'

import IconPrev from 'src/assets/icons/arrow-left.svg'
import IconNext from 'src/assets/icons/arrow-right.svg'

import s from './PayStubChooseTemplate.module.scss'

const cx = cn.bind(s)

type TTemplatePagination = {
	className?: string
	payStubs: number
	setActiveDataTemplate: Dispatch<SetStateAction<number>>
	activeDataTemplate: number
}

export const TemplatePagination: FC<TTemplatePagination> = ({
	payStubs,
	activeDataTemplate,
	setActiveDataTemplate,
	className,
}) => {
	const prevActiveDataTemplate = useCallback(() => {
		setActiveDataTemplate((prev) => prev - 1)
	}, [setActiveDataTemplate])

	const nextActiveDataTemplate = useCallback(() => {
		setActiveDataTemplate((prev) => prev + 1)
	}, [setActiveDataTemplate])

	const chooseActiveDataTemplate = useCallback(
		(index: number) => {
			setActiveDataTemplate(index)
		},
		[setActiveDataTemplate],
	)

	return (
		<div className={cx('pagination', className)}>
			<ul className={cx('pagination__list')}>
				<button
					type="button"
					onClick={prevActiveDataTemplate}
					className={cx('nav-btn-prev', 'nav-btn', {
						'nav-btn__icon--disabled': activeDataTemplate === 0,
					})}>
					<IconPrev />
				</button>
				{Array.from(Array(payStubs).keys()).map((item, index) => (
					<li
						key={index}
						aria-hidden="true"
						data-testid="pagination-item"
						onClick={() => chooseActiveDataTemplate(index)}
						className={cx('pagination__item', activeDataTemplate === index ? 'active' : '')}>
						{index + 1}
					</li>
				))}
				<button
					type="button"
					onClick={nextActiveDataTemplate}
					className={cx('nav-btn-next', 'nav-btn', {
						'nav-btn__icon--disabled': activeDataTemplate === payStubs - 1,
					})}>
					<IconNext />
				</button>
			</ul>
		</div>
	)
}
